import { Search } from 'lucide-react';

import { Button, Text } from '@/design-system';
import { cn } from '@/utils/tailwind';

export default function EmptyState({
  icon,
  title,
  description,
  action,
  fancyIcon,
  docsLink,
  className,
  size = 'xs',
}: {
  icon?: React.ReactNode;
  title?: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  fancyIcon?: boolean;
  docsLink?: string;
  className?: string;
  size?: 'xs' | 'md' | 'lg';
}) {
  const mIcon = fancyIcon ? (
    <div className="mx-auto flex h-[52px] w-[52px] items-center justify-center rounded-full bg-brand-secondary">
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-secondary text-brand-primary">
        {icon ?? <Search />}
      </div>
    </div>
  ) : (
    <div className="rounded-xl border border-secondary p-3">
      {icon ?? <Search />}
    </div>
  );

  return (
    <div className={cn('flex flex-col items-center space-y-4', className)}>
      {mIcon}
      <div className={cn(`max-w-${size}`)}>
        <h3 className="text-center text-base font-medium text-ls-black">
          {title}
        </h3>
        <p className="mt-2 text-center text-sm text-tertiary">{description}</p>
      </div>
      <div className="flex items-center gap-2">
        {action}
        {docsLink && (
          <a href={docsLink} target="_blank" rel="noopener noreferrer">
            <Button variant="plain" size="md">
              <Text>Learn more</Text>
            </Button>
          </a>
        )}
      </div>
    </div>
  );
}
